import React from "react";
import { Box, Paper, Skeleton, Typography } from "@mui/material";
import {
  CENTER_CHANNELS,
  NotificationUsage,
  formatMoney,
} from "../../services/notificationCenterService";
import { CHANNEL_NAMES } from "./channelText";

const number = (value: number) => value.toLocaleString();

/**
 * One tile per channel: messages sent, with failures underneath, and what the
 * paid channels were charged.
 */
const UsageTiles: React.FC<{ usage: NotificationUsage | null; loading: boolean }> = ({
  usage,
  loading,
}) => {
  if (!loading && usage && !usage.available) {
    return (
      <Typography sx={{ color: "text.secondary", fontSize: "0.9rem" }}>
        Message counts are not available right now. Try again in a few minutes.
      </Typography>
    );
  }

  return (
    <Box
      sx={{
        display: "grid",
        gap: 1.5,
        gridTemplateColumns: { xs: "repeat(2, 1fr)", md: "repeat(4, 1fr)" },
      }}
    >
      {CENTER_CHANNELS.map((channel) => {
        const counts = usage?.totals?.[channel];
        const paid = channel === "SMS" || channel === "WHATSAPP";
        return (
          <Paper
            key={channel}
            elevation={0}
            sx={{ border: "1px solid", borderColor: "divider", borderRadius: 3, p: 2 }}
          >
            <Typography sx={{ fontSize: "0.85rem", color: "text.secondary" }}>
              {CHANNEL_NAMES[channel]}
            </Typography>
            {loading || !counts ? (
              <Skeleton width={60} height={36} />
            ) : (
              <>
                <Typography sx={{ fontSize: "1.6rem", fontWeight: 700, lineHeight: 1.3 }}>
                  {number(counts.sent)}
                </Typography>
                <Typography
                  sx={{
                    fontSize: "0.8rem",
                    color: counts.failed ? "#A32B22" : "text.secondary",
                  }}
                >
                  {counts.failed ? `${number(counts.failed)} failed` : "delivered"}
                  {counts.pending ? ` · ${number(counts.pending)} sending` : ""}
                </Typography>
                <Typography sx={{ fontSize: "0.8rem", color: "text.secondary", mt: 0.25 }}>
                  {paid ? `${formatMoney(counts.amount, usage?.currency)} charged` : "Included"}
                </Typography>
              </>
            )}
          </Paper>
        );
      })}
    </Box>
  );
};

export default UsageTiles;
